export const FEATURE_NAME = 'SmartCompose';

/**
 * Personalization Hints
 */
export const SHOW_TAB = 'ShowTab';
export const HIDE_TAB = 'HideTab';

/**
 * Personalization Signals
 */
export const SUGGESTION_ACCEPTED = 'SuggestionAccepted';
export const SAT = 'SAT';

export const SUGGESTION_REJECTED = 'SuggestionRejected';
export const DSAT = 'DSAT';
